import * as _ from 'lodash';
import createSelector from 'selectorator';
import { User } from '../../types';

const getAccessRequests = createSelector(['organizationAccessRequests.organizationAccessRequests']);
const getAccessRequestList = createSelector([getAccessRequests], _.values);

const getOrganizationUserEmails = (_state, props) =>
  props.organization &&  props.organization.users.map((user: User) => user.email);

export default {
  getActiveRequestsForOrganization: createSelector([getAccessRequestList, getOrganizationUserEmails],
    (allAccessRequests, organizationUserEmails) => {
      return allAccessRequests
        .reduce((coll, accessRequest) => {
          if (organizationUserEmails.includes(accessRequest.email)) {
            return coll;
          }
          coll[accessRequest.id] = accessRequest;
          return coll;
        }, {});
    }),
};
